import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import AnswerPage from "@/pages/AnswerPage";
import ThankYouPage from "@/pages/ThankYouPage";
import AdminPage from "@/pages/AdminPage";
import OwnerPage from "@/pages/OwnerPage";
import OccasionsPage from "@/pages/OccasionsPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import RemovalPage from "@/pages/RemovalPage";
import CelebrationPage from "@/pages/CelebrationPage";
import FreeLinkPage from "@/pages/FreeLinkPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/v/:slug" element={<AnswerPage />} />
          <Route path="/v/:slug/kiitos" element={<ThankYouPage />} />
          <Route path="/admin/:slug/:token" element={<AdminPage />} />
          <Route path="/tilaisuudet" element={<OccasionsPage />} />
          <Route path="/tietosuoja" element={<PrivacyPage />} />
          <Route path="/kayttoehdot" element={<TermsPage />} />
          <Route path="/käyttöehdot" element={<Navigate to="/kayttoehdot" replace />} />
          <Route path="/poista/:token" element={<RemovalPage />} />
          <Route path="/juhla/:token" element={<CelebrationPage />} />
          <Route path="/free/:token" element={<FreeLinkPage />} />
          <Route path="/owner/:secret" element={<OwnerPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
